import React, { useMemo } from 'react';
import { getFeatureFlags } from 'UI/utils';

const FeatureFlagsContext = React.createContext(null);

/**
 * @param {Object} props
 * @param {string[]} [props.value]
 * @param {undefined} props.children
 */
const FeatureFlagsProvider = ({ value, children }) => {
  const featureFlags = useMemo(() => value ?? getFeatureFlags(), [value]);

  const context = useMemo(
    () => ({
      checkIfFeatureFlagEnabled: flagName => featureFlags.includes(flagName)
    }),
    [featureFlags]
  );

  return <FeatureFlagsContext.Provider value={context}>{children}</FeatureFlagsContext.Provider>;
};

export const useFeatureFlags = () => {
  const context = React.useContext(FeatureFlagsContext);
  if (!context) {
    throw new Error('useFeatureFlags must be used within a FeatureFlagsProvider');
  }
  return context;
};

export default FeatureFlagsProvider;
